import React from 'react';
import { fetchGet } from '../api/config';
import { Link } from 'react-router-dom';

const crumb = {
	"home": {
		name: {
			"chinese": "首页",
			"english": "Home"
		},
		url: '/'
	},
	"product": {
		name: {
			"chinese": "产品",
			"english": "Product"
		},
		url: '/product'
	}
}
export default class Production extends React.Component {
	state = {
		product: {},
		currentTabId: null, // 对有tab的页面（如其他专线）才适用
	};
	constructor(props) {
		super(props);
	}
	componentDidMount() {
		this.getProductionData();
	}
	getProductionData(value = null) {
		let name = this.props.match.params.name;
		if (value !== null) name = value;
		fetchGet('/product/' + name + '.json', {}).then(data => {
			if (typeof data == 'object') {
				this.setState({
					product: data,
					currentTabId: data[this.props.language].initTabId || null,
				})
			}
		})
	}
	setProductBanner(banner) {
		if (!banner) return;
		return (
			<div className="production-content-banner">
				<img src={banner.image} alt="" />
				{/*<div className="product-content-banner-info" style={{color:banner.color}}>*/}
				{/*<h2>{banner.info.title}</h2>*/}
				{/*{banner.info.miantitle.map((value,index)=>*/}
				{/*<p key={index.toString()}>{value}</p>*/}
				{/*)}*/}
				{/*</div>*/}
			</div>
		)
	}
	shouldComponentUpdate(nextprops, nextstate) {
		let name = nextprops.match.params.name;
		if (name !== this.props.match.params.name) {
			this.getProductionData(name);
		}
		return true;
	}

	render() {
		let { language } = this.props;
		let { product } = this.state;
		let currentProduct = {};
		if (!!product[language]) {
			currentProduct = product[language]
		}
		let List = '';
		if (!!product[language]) {
			List = product[language].data.map((data, key) => {
				if (data.type === "chunk") {
					return (
						<div className="production--content-list" key={key.toString()} style={{ display: this.state.currentTabId && data.tabId !== this.state.currentTabId ? 'none' : 'block' }}>
							<div className="pms-common-title">
								{/*<span className="pms-square"></span>*/}
								{data.title}
							</div>
							<div className="pms-circle-list clear">
								{
									data.chunkcontent.map((res, subkey) =>
										<div className="pms-section" key={subkey.toString()}>
											{/*<span className={data.chunkcontent.length>1?'pms-department-name':'hide'}>{subkey>9?subkey+1:'0'+(subkey+1)}</span>*/}
											<div>
												<h4>{res.title}</h4>
												<ul>
													{
														Array.isArray(res.data)
															// 当res.data为数组时，如备注栏
															? res.data.map(
																(item, i) =>
																(<li className="pms-name-in-info clear" key={i}>
																	{
																		item.map((subItem, j) => (<span key={j}>{subItem}</span>))
																	}
																</li>)
															)
															:
															('platform' in res && res.platform && Array.isArray(res.platform))
																? res.platform.map((item, i) => {
																	return (
																		<div>
																			<li className="pms-name-in-info h6Weights" key={i}>{item.title}</li>
																			{
																				Object.keys(item.data).map((itemKey, ci) =>
																				(<li className="pms-name-in-info" key={ci}>
																					<h6>{itemKey}</h6>
																					{
																						item.data[itemKey].map((para, j) => (<p key={j}>{para}</p>))
																					}
																				</li>))
																			}
																		</div>
																	)
																})
																// 当res.data为对象时，一般情况
																: Object.keys(res.data).map(
																	(itemKey, i) =>
																	(<li className="pms-name-in-info" key={i}>
																		<h6 className={res.data[itemKey].length ? '' : 'h6Weights'}>{itemKey}</h6>
																		{
																			res.data[itemKey].map((para, j) => (<p key={j}>{para}</p>))
																		}
																	</li>)
																)
													}
												</ul>
												<div className="production--content-list-logo">
													<img src={'/productimage/' + res.logo} alt="" />
												</div>
											</div>
										</div>
									)
								}
							</div>
						</div>
					)
				}
				if (data.type === "chunkBlock") {
					return (
						<div className="production--content-block" key={key.toString()} style={{ display: this.state.currentTabId && data.tabId !== this.state.currentTabId ? 'none' : 'block' }}>
							<div className="pms-common-title text-center">
								{data.title}
							</div>
							<div className="pms-circle-block">
								{
									data.chunkcontent.map((res, subkey)=> 
										<div className="pms-section" key={subkey.toString()}>
											<div className="pms-section-content">
												<p className='section-title'>{res.title}</p>
												{
													res.data.map((sp, pIndex)=>
														<p key={subkey.toString() + '-' + pIndex.toString()}>{sp}</p>
													)
												}
											</div>
											<div className="pms-section-img">
												<img src={res.image} alt="" />
											</div>
										</div>
									)
								}
							</div>
						</div>
					)
				}
				if (data.type == "normal") {
					return (
						<div className="production--content-list" key={key.toString()}>
							<div className="pms-common-title">
								{data.title}
							</div>
							<div className="production--content-paragraph">
								<p>{data.normalcontent}</p>
							</div>
						</div>
					)
				}
				if (data.type === "tabs") {
					return (
						<ul className="production--tabs-bar clear" key={key.toString()}>
							{
								data.tabsList.map((tab, i) =>
									(<li key={tab.id} className={this.state.currentTabId === tab.id ? 'active' : ''} onClick={(e) => this.setState({ currentTabId: tab.id })}><span>{tab.label}</span></li>)
								)
							}
						</ul>
					)
				}
			})
		}
		return (
			<div className="pms-container pms-production">
				<div className="page-crumbs">
					<span><Link to="/">{crumb.home.name[language]}</Link> &gt;</span>
					<span><Link to={'/product/' + this.props.match.params.name}>{crumb.product.name[language]}</Link> &gt;</span>
					<span>{currentProduct.title}</span>
				</div>
				<div className="pms-production-container">
					<div className="pms-news-header">
						<p className="news-maintitle">{currentProduct.title}</p>
						{/* <p className="news-time">{currentProduct.time}</p> */}
					</div>
					<div className="production-content">
						{this.setProductBanner(currentProduct.banner)}
						{List}
						<div className="production--content-tip">{currentProduct.tip}</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./public/views/production.js